import MultiOptionsSwitch from "components/common/form/MultioptionSwitch";
import { actions as globalActions } from "components/global/logic/actions";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { createDeepEqualSelector, mapToSelectValues } from "./utils";

const TypeAssociationSwitch = ({ associationTypes = [], value = [], onChange = () => {}, getAssociationTypes = () => {} }) => {

    useEffect(() => {
        if (!associationTypes.length) {
            getAssociationTypes();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!value && associationTypes.length) onChange(associationTypes[0].value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [associationTypes.length]);

    return <MultiOptionsSwitch value={value} options={associationTypes} onChange={onChange} />;
};

TypeAssociationSwitch.propTypes = {
    associationTypes: PropTypes.array,
    value: PropTypes.object,
    onChange: PropTypes.func,
    getAssociationTypes: PropTypes.func,
};



const selector = createDeepEqualSelector(
    (state) => state.globalApp.associationTypes,
    (associationTypes) => {
        const assocTypes = mapToSelectValues(associationTypes);
        return { associationTypes: assocTypes };
    }
);

function mapDispatchToProps(dispatch) {
    return {
        getAssociationTypes: () => dispatch(globalActions.GET_ASSOCIATION_TYPES.send()),
    };
}

TypeAssociationSwitch.propTypes = {
    associationTypes: PropTypes.array,
    value: PropTypes.object,
};


export default connect((state) => selector(state), mapDispatchToProps)(TypeAssociationSwitch);
